<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-6"><a href="#/Satan's_Lullaby2#Contents-A">Epigraph</a></p>
<p class="fp para-style-override-3">It is difficult to fight against anger,<br/>for a man will buy revenge with his soul.</p>
<p class="body para-style-override-4">—Heraclitus, quoted in Aristotle’s <span class="Italic">Politics<br/></span>(Trans. Benjamin Jowett)<span class="Italic"></span></p>
<p class="body"></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Satans_Lullaby5.vue?7491800c